import { useAppSelector } from '../..'
import { type ITermCDG } from '../../../models/Term'

export const getTerm = (): ITermCDG | null => useAppSelector((state) => state.terms?.term)
export const getTermLoading = (): boolean => useAppSelector((state) => state.terms?.termLoading)
